export const sendedData = {
    allDataSent: ['Все данные были успешно отправлены на сервер', 'All data was sent successfully to the server'],
    completeCheckList: ['Пожалуйста, заполните контрольный список', 'Please complete check list'],
    crewInfoOnSummaryPage: ['Данные по экипажу на странице итоговой информации', 'Crew info on summary page'],
    enterRequiredFields: ['Пожалуйста, заполните необходимые поля: ', 'Please enter required fields: '],
    partDataSent: [
        'Все данные были успешно отправлены, но часть данных не была обновлена на сервере: \n {{messages}}',
        'All data was sent successfully, but part of the data was not updated on server: \n {{messages}}',
    ],
    pilotFlightLanding: ['Пилотирующий на посадке', 'Pilot flight landing'],
    pilotFlightTakeOff: ['Пилотирующий на взлёте', 'Pilot flight take-off'],
    reportSentTaskNotSent: [
        'Доклады были успешно отправлены, но данные о полётном задании ещё не отправлены. Пожалуйста, попробуйте отправить их позже.',
        'Reports were sent successfully, but the flight task data have not been sent yet. Please try to send them again later.',
    ],
    resetDataLeg: ['Сбросить данные по участку', 'Reset data for leg'],
    selectLegsSendingSendSignReports: [
        'Выбор участка для отправки или отправка только подписей и докладов',
        'Select legs for sending or send only signatures and reports',
    ],
    sendDataSelectedLegs: ['Отправить всё по участкам', 'Send all data for selected legs'],
    sendSignsReports: ['Отправить подписи и доклады', 'Send signs and reports'],
    taskNotSent: [
        'Данные о полётном задании ещё не отправлены. Пожалуйста, попробуйте отправить их позже',
        'The flight task data have not been sent yet. Please try to send them again later.',
    ],
    taskSentReportNotSent: [
        'Данные о полётном задании были успешно отправлены, но доклады еще не отправлены. Пожалуйста, попробуйте отправить их позже',
        'The flight task data were sent successfully, but the reports have not been sent yet. Please try to send them again later.',
    ],
};
